import Mockman from "mockman-js";
export function MockAPI() {
  return (
    <div style={{ marginTop: "5rem" }} className="MockAPI">
      <Mockman />
    </div>
  );
}